import { FC } from 'react';
import { Navigate, NavigateProps } from 'react-router-dom';
import { useLocalizedPath } from '@app/app/i18n/hooks/use-localized-path';

/**
 * Компонент Navigate, который автоматически добавляет языковой префикс к пути редиректа,
 * сохраняя языковой префикс из текущего URL.
 *
 * @example
 * // Если текущий URL: /ru/workspace/create/
 * <LocalizedNavigate to="/workspace/text-to-slides/" />
 * // -> редирект на /ru/workspace/text-to-slides/
 */
export const LocalizedNavigate: FC<Omit<NavigateProps, 'to'> & { to: string }> = ({
  to,
  ...props
}) => {
  const localizedPath = useLocalizedPath(to);

  return <Navigate to={localizedPath} {...props} />;
};
